import "./index.scss";
// import { $ } from "@olmokit/dom";

/**
 * Component: Cover
 */
export function Cover() {
  console.log("Cover mounted.");
}
